<template>
  <div class="avatar">
    <img v-if="user.avatar" :src="`https://www.globulo-quest.org/${user.avatar}`" alt="" title=""/>
    <img v-else :src="require(`@/assets/images/badges/${user.title}-${user.gender.toLowerCase()}.jpg`)" alt="" title=""/>
  </div>
</template>

<script>
  export default {
    props: [ 'user']
  }
</script>

<style scoped>
  .avatar {
    border-radius: 50%;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
</scoped>
